var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "poll" } }, [
    _c("iframe", { attrs: { src: _vm.asset.poll_url } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }